import MaterialListItem, { ListItemProps } from '@mui/material/ListItem';

export function ListItem(props: ListItemProps) {
    return <MaterialListItem data-testid={'ListItem-container'} {...props} />;
}

export default ListItem;
